import Loadable from '../../../../../components/loadable';

export default Loadable(() =>
  import(/* webpackChunkName: "business-demo-store-menu" */ './index')
);
